function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useRef } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import env from "../../services/environment";
import { useGlobalContext } from "../../services/context";
/**
 * Simple re captcha.
 *
 * @param {number} number nombre de caractères dans le captcha
 * @param {callbakc} onSuccess quand le captcha est en succès
 * @param {callbakc} onFailure quand le captcha est en échec
 * @param {boolean} reload permet si l'utilisateur peut recharger le captcha
 * @param {string} reloadText Texte pour recharger le captcha
 *
 * @licence MIT
 */

export default (function (_ref) {
  var number = _ref.number,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      reset = _ref.reset;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      token = _useState2[0],
      setToken = _useState2[1];

  var _useGlobalContext = useGlobalContext(),
      locale = _useGlobalContext.locale;

  var captchaRef = useRef();
  var key = env.get('captcha_token');

  var handleCaptchaVerification = function handleCaptchaVerification(token, ekey) {
    setToken(token, ekey);
    onSuccess(token, ekey);
  }; // useEffect(() => {
  //     loadCaptchaEnginge(number);
  // }, [number]);


  useEffect(function () {
    if (!reset || !captchaRef.current) {
      return;
    }

    captchaRef.current.resetCaptcha();
  }, [reset]);

  if (!key) {
    return null;
  }

  return /*#__PURE__*/React.createElement(HCaptcha, {
    sitekey: key,
    onVerify: handleCaptchaVerification,
    onError: onFailure,
    onExpire: onFailure,
    ref: captchaRef,
    languageOverride: locale
  });
});